import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  useEffect(() => {
    const m = document.querySelector('meta[name="robots"]');
    const prev = m?.getAttribute("content");
    m?.setAttribute("content", "noindex, follow");
    return () => { if (m && prev) m.setAttribute("content", prev); };
  }, []);
  return (
    <div data-testid="not-found-page" className="mx-auto max-w-3xl px-4 py-24 text-center space-y-4">
      <h1 className="font-display text-3xl sm:text-4xl font-bold">Page not found</h1>
      <p className="text-slate-400">The page you're looking for doesn't exist or has moved.</p>
      <div className="flex justify-center gap-6 text-sm font-semibold">
        <Link to="/" data-testid="not-found-home-link" className="text-sky-400 hover:underline">Home</Link>
        <Link to="/news" data-testid="not-found-archive-link" className="text-sky-400 hover:underline">All stories</Link>
        <Link to="/faqs" className="text-sky-400 hover:underline">FAQs</Link>
      </div>
    </div>
  );
}
